<template>
  <div>
    <div class="bg-white py-6">
      <!-- Replace with your content -->
      <div>
        <div class="md:flex md:items-center md:justify-between sm:px-6 md:px-8">
          <div class="flex-1 min-w-0">
            <h2
              class="text-2xl font-bold leading-7 text-gray-800 sm:text-3xl sm:truncate"
            >
              {{ $t("messages.gameReport.gameReport") }}
            </h2>
          </div>
          <div class="mt-4 flex-shrink-0 flex md:mt-0 md:ml-4"></div>
        </div>
      </div>
    </div>
    <!-- /End replace -->

    <nav
      class="bg-white border-b border-t border-gray-200 flex"
      aria-label="Breadcrumb"
    >
      <ol class="w-full mx-auto px-4 flex space-x-4 sm:px-6 md:px-8">
        <li class="flex">
          <div class="flex items-center">
            <a
              href="javascript:void(0)"
              class="text-gray-400 hover:text-gray-500"
            >
              <HomeIcon class="flex-shrink-0 h-5 w-5" aria-hidden="true" />
              <span class="sr-only">Home</span>
            </a>
          </div>
        </li>
        <li v-for="page in pages" :key="page.name" class="flex">
          <div class="flex items-center">
            <svg
              class="flex-shrink-0 w-6 h-full text-gray-200"
              viewBox="0 0 24 44"
              preserveAspectRatio="none"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" />
            </svg>
            <router-link
              :to="page.href"
              class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
              :aria-current="page.current ? 'page' : undefined"
              >{{ page.name }}</router-link
            >
          </div>
        </li>
      </ol>
    </nav>

    <div class="">
      <div
        class="space-y-8 divide-y divide-gray-200 bg-white py-3 border-b text-center"
      >
        <div
          class="flex items-center justify-center sm:justify-evenly flex-wrap xs:justify-evenly"
        >
          <div class="md:ml-4">
            <Listbox as="div" v-model="selected">
              <div class="relative w-48">
                <ListboxButton
                  class="bg-white relative w-full border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                >
                  <span class="block truncate">{{ selected.label }}</span>
                  <span
                    class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none"
                  >
                    <SelectorIcon
                      class="h-5 w-5 text-gray-400"
                      aria-hidden="true"
                    />
                  </span>
                </ListboxButton>

                <transition
                  leave-active-class="transition ease-in duration-100"
                  leave-from-class="opacity-100"
                  leave-to-class="opacity-0"
                >
                  <ListboxOptions
                    class="absolute z-10 mt-1 w-full bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm"
                  >
                    <ListboxOption
                      as="template"
                      v-for="month in months"
                      :key="month.label"
                      :value="month"
                      @click="search(month)"
                    >
                      <li
                        :class="[
                          'hover:text-white hover:bg-indigo-600 text-gray-900 cursor-default select-none relative py-2 pl-3 pr-9',
                        ]"
                      >
                        <span
                          :class="[
                            selected.value == month.value
                              ? 'font-semibold'
                              : 'font-normal',
                            'block truncate text-left',
                          ]"
                        >
                          {{ month.label }}
                        </span>

                        <span
                          v-if="selected.value == month.value"
                          :class="[
                            'absolute inset-y-0 right-0 flex items-center pr-4 pl-5',
                          ]"
                        >
                          <CheckIcon class="h-5 w-5" aria-hidden="true" />
                        </span>
                      </li>
                    </ListboxOption>
                  </ListboxOptions>
                </transition>
              </div>
            </Listbox>
          </div>

          <div class="max-w-lg w-64 lg:max-w-xs">
            <label for="search" class="sr-only">Search</label>
            <div class="relative text-gray-600 focus-within:text-gray-600">
              <div
                class="pointer-events-none absolute inset-y-0 pl-1 left-0 flex items-center"
              >
                {{ $t("messages.gameReport.from") }}
                :
              </div>
              <input
                id="from"
                v-model="fromDate"
                maxlength="10"
                @change="searchRage($event)"
                class="block w-full bg-white py-2 pl-14 focus:bg-white pr-3 border border-transparent rounded-md leading-5 text-gray-900 placeholder-gray-500 focus:ring-offset-blue-600 focus:ring-white focus:border-white sm:text-sm"
                placeholder="From"
                type="date"
                name="from"
              />
            </div>
          </div>
          <div class="max-w-lg w-64 lg:max-w-xs">
            <label for="search" class="sr-only">Search</label>
            <div class="relative text-gray-600 focus-within:text-gray-600">
              <div
                class="pointer-events-none absolute inset-y-0 pl-1 left-0 flex items-center"
              >
                {{ $t("messages.gameReport.to") }}:
              </div>
              <input
                id="from"
                v-model="toDate"
                maxlength="10"
                @change="searchRage($event)"
                class="block w-full bg-white py-2 pl-10 focus:bg-white pr-3 border border-transparent rounded-md leading-5 text-gray-900 placeholder-gray-500 focus:ring-offset-blue-600 focus:ring-white focus:border-white sm:text-sm"
                placeholder="To"
                type="date"
                name="to"
              />
            </div>
          </div>
          <div class="mt-4 flex-shrink-0 flex md:mt-2 md:ml-1 pr-8">
            <button
              type="button"
              @click="exports()"
              class="ml-3 inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-500"
            >
              <font-awesome-icon class="mr-2" :icon="['far', 'file-export']" />
              {{ $t("messages.gameReport.exportReport") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="px-8 py-6" v-show="!isLoaded">
      <div
        class="space-y-8 divide-y divide-gray-200 bg-white px-10 py-9 rounded-md shadow-md text-center"
      >
        <font-awesome-icon
          class="text-gray-500"
          :icon="['fas', 'circle-notch']"
          transform="grow-6"
          spin
        />
      </div>
    </div>

    <div class="py-6" v-show="isLoaded">
      <div
        class="px-8 md:flex md:flex-row md:justify-between grid grid-cols-2 gap-4 gap-y-4 place-items-center"
      >
        <div class="w-4/5 md:w-1/5">
          <div class="shadow p-6 bg-blue-100 rounded-md h-28">
            <div class="font-bold text-lg">
              {{
                dataRows.totalPlayer.toLocaleString("en", { useGrouping: true })
              }}
            </div>
            <div class="text-sm">
              {{ $t("messages.gameReport.totalPlayers") }}
            </div>
          </div>
        </div>
        <div class="w-4/5 md:1/5">
          <div class="shadow p-6 bg-indigo-100 rounded-md h-28">
            <div class="font-bold text-lg">
              {{
                dataRows.totalBet.toLocaleString("en", { useGrouping: true })
              }}
            </div>
            <div class="text-sm">
              {{ $t("messages.gameReport.totalBetRounds") }}
            </div>
          </div>
        </div>
        <div class="w-4/5 md:1/5">
          <div class="shadow p-6 bg-yellow-100 rounded-md h-28">
            <div class="font-bold text-lg">
              {{
                parseFloat(dataRows.totalBetAmount / 100).toLocaleString("en", {
                  useGrouping: true,
                  minimumFractionDigits: 2,
                })
              }}
            </div>
            <div class="text-sm">
              {{ $t("messages.gameReport.totalBetAmount") }}
            </div>
          </div>
        </div>
        <div class="w-4/5 md:1/5">
          <div class="shadow p-6 bg-green-100 rounded-md h-28">
            <div class="font-bold text-lg">
              {{
                (
                  parseInt(dataRows.totalWinLoss) /
                    100 || 0
                ).toLocaleString("en", {
                  useGrouping: true,
                  minimumFractionDigits: 2,
                })
              }}
            </div>
            <div class="text-sm">
              {{ $t("messages.gameReport.totalWinloss") }}
            </div>
          </div>
        </div>
      </div>

      <div class="sm:px-6 md:px-8">
        <div class="bg-white shadow sm:rounded-md mt-6">
          <div
            class="shadow overflow-x-auto border-b border-gray-200 sm:rounded-lg"
          >
            <table class="table min-w-full divide-y divide-gray-200">
              <thead class="bg-gray-50">
                <tr>
                  <th
                    scope="col"
                    @click="doSort('gameId')"
                    class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer"
                  >
                    {{ $t("messages.gameReport.providerName") }}
                  </th>
                  <th
                    scope="col"
                    @click="doSort('totalPlayer')"
                    class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-center cursor-pointer"
                  >
                    {{ $t("messages.gameReport.player") }}
                  </th>
                  <th
                    scope="col"
                    @click="doSort('totalBet')"
                    class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-center cursor-pointer"
                  >
                    {{ $t("messages.gameReport.totalBetRounds") }}
                  </th>
                  <th
                    scope="col"
                    @click="doSort('totalBetAmount')"
                    class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-right cursor-pointer"
                  >
                    {{ $t("messages.gameReport.betAmount") }}
                  </th>
                  <th
                    scope="col"
                    @click="doSort('totalValidBet')"
                    class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-right cursor-pointer"
                  >
                    {{ $t("messages.gameReport.validBetAmount") }}
                  </th>
                  <th
                    scope="col"
                    @click="doSort('totalWinLoss')"
                    class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-right cursor-pointer"
                  >
                    {{ $t("messages.gameReport.winloss") }}
                  </th>
                  <th
                    scope="col"
                    @click="doSort('winLossMeanPercentage')"
                    class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-right cursor-pointer"
                  >
                    {{ $t("messages.gameReport.winlossPercent") }}
                  </th>
                  <th
                    scope="col"
                    @click="doSort('totalRawBet')"
                    class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-right cursor-pointer"
                  >
                    Raw Bet
                  </th>
                  <th
                    scope="col"
                    @click="doSort('totalRawSettle')"
                    class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-right cursor-pointer"
                  >
                    Raw Settle
                  </th>
                  <th
                    scope="col"
                    @click="doSort('totalCancelAmount')"
                    class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-right cursor-pointer"
                  >
                    Cancel Amount
                  </th>
                  <th
                    scope="col"
                    @click="doSort('totalCancelCount')"
                    class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-right cursor-pointer"
                  >
                    Cancel Count
                  </th>
                </tr>
              </thead>
              <tbody
                v-if="dataRows.data && dataRows.data.length > 0"
                class="bg-white divide-y divide-gray-200"
              >
                <tr
                  v-for="(data, i) in dataRows.data"
                  :key="i"
                  class="hover:bg-gray-50"
                >
                  <td
                    class="px-3 py-4 whitespace-nowrap text-sm text-gray-500"
                    style="color: #4169e1"
                  >
                    {{ data.gameId }}
                  </td>
                  <td
                    class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-center"
                  >
                    {{
                      data.totalPlayer.toLocaleString("en", {
                        useGrouping: true,
                        minimumFractionDigits: 0,
                      })
                    }}
                  </td>
                  <td
                    class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-center"
                  >
                    {{
                      data.totalBet.toLocaleString("en", {
                        useGrouping: true,
                        minimumFractionDigits: 0,
                      })
                    }}
                  </td>
                  <td
                    class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right"
                  >
                    {{
                      parseFloat(data.totalBetAmount / 100).toLocaleString(
                        "en",
                        { useGrouping: true, minimumFractionDigits: 2 }
                      )
                    }}
                  </td>
                  <td
                    class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right"
                  >
                    {{
                      parseFloat(data.totalValidBet / 100).toLocaleString(
                        "en",
                        { useGrouping: true, minimumFractionDigits: 2 }
                      )
                    }}
                  </td>
                  <td
                    class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right"
                    :style="
                      (parseInt(data.totalWinLoss) 
                        ) /
                        100 >=
                      0
                        ? { color: 'green' }
                        : { color: 'red' }
                    "
                  >
                    {{
                      ((parseInt(data.totalWinLoss)) / 100).toLocaleString("en", {useGrouping: true, minimumFractionDigits: 2,})
                    }}
                  </td>
                  <td
                    class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right"
                    :style="
                      parseInt(data.totalWinLoss)   >=
                      0
                        ? { color: 'green' }
                        : { color: 'red' }
                    "
                  >
                    {{
                      (
                        (parseInt(data.totalWinLoss) /
                          parseInt(data.totalBetAmount)) *
                          100 || 0
                      ).toLocaleString("en", {
                        useGrouping: true,
                        minimumFractionDigits: 4,
                      })
                    }}%
                  </td>
                  <!-- <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right" :style="(parseFloat(data.winLossMeanPercentage) >= 0) ? {'color': 'green'} : {'color': 'red'}">
                    {{ parseFloat(data.winLossMeanPercentage).toLocaleString('en', { useGrouping:true, minimumFractionDigits: 4 })  }}%
                  </td> -->
                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{ parseFloat(data.totalRawBet / 100).toLocaleString("en", { useGrouping: true, minimumFractionDigits: 2 }) }}
                  </td>
                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{ parseFloat(data.totalRawSettle / 100).toLocaleString("en", { useGrouping: true, minimumFractionDigits: 2 }) }}
                  </td>
                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{ parseFloat(data.totalCancelAmount / 100).toLocaleString("en", { useGrouping: true, minimumFractionDigits: 2 }) }}
                  </td>
                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{ data.totalCancelCount.toLocaleString("en", { useGrouping: true, minimumFractionDigits: 0 }) }}
                  </td>
                </tr>
              </tbody>
              <tfoot class="bg-gray-100 font-bold">
                <tr>
                  <td
                    class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-left"
                  >
                    {{ $t("messages.gameReport.total") }}
                  </td>
                  <td
                    class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-center"
                  >
                    {{
                      dataRows.totalPlayer.toLocaleString("en", {
                        useGrouping: true,
                        minimumFractionDigits: 0,
                      })
                    }}
                  </td>
                  <td
                    class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-center"
                  >
                    {{
                      dataRows.totalBet.toLocaleString("en", {
                        useGrouping: true,
                        minimumFractionDigits: 0,
                      })
                    }}
                  </td>
                  <td
                    class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right"
                  ></td>
                  <td
                    class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right"
                  >
                    {{
                      parseFloat(dataRows.totalValidBet / 100).toLocaleString(
                        "en",
                        {
                          useGrouping: true,
                          minimumFractionDigits: 2,
                        }
                      )
                    }}
                  </td>
                  <td
                    class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right"
                  >
                    {{
                      ((parseInt(dataRows.totalWinLoss)) / 100).toLocaleString("en", {useGrouping: true, minimumFractionDigits: 2,})
                    }}
                  </td>
                  <td
                    class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right"
                  ></td>
                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{ parseFloat(dataRows.totalRawBet / 100).toLocaleString("en", { useGrouping: true, minimumFractionDigits: 2 }) }}
                  </td>
                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{ parseFloat(dataRows.totalRawSettle / 100).toLocaleString("en", { useGrouping: true, minimumFractionDigits: 2 }) }}
                  </td>
                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{ parseFloat(dataRows.totalCancelAmount / 100).toLocaleString("en", { useGrouping: true, minimumFractionDigits: 2 }) }}
                  </td>
                  <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                    {{ dataRows.totalCancelCount != null ? dataRows.totalCancelCount.toLocaleString("en", { useGrouping: true, minimumFractionDigits: 0 }) : 0 }}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  CheckCircleIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  MailIcon,
  HomeIcon,
  SearchIcon,
  CheckIcon,
  SelectorIcon,
} from "@heroicons/vue/solid";
import {
  Listbox,
  ListboxButton,
  ListboxLabel,
  ListboxOption,
  ListboxOptions,
} from "@headlessui/vue";
import { inject, onMounted, ref } from "@vue/runtime-core";
import { useStore } from "vuex";
import * as dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { useRoute, useRouter } from "vue-router";

dayjs.extend(localizedFormat);

const pages = [{ name: "Game Report", href: "", current: true }];

export default {
  components: {
    ChevronLeftIcon,
    ChevronRightIcon,
    CheckCircleIcon,
    MailIcon,
    HomeIcon,
    SearchIcon,
    Listbox,
    ListboxButton,
    ListboxLabel,
    ListboxOption,
    ListboxOptions,
    CheckIcon,
    SelectorIcon,
  },
  setup() {
    const axios = inject("$axios");
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const toDate = ref("");
    const fromDate = ref("");
    let sortBy = ref([]);

    const startDate = dayjs();
    const diff = startDate.diff("2021-07-01", "months");
    let months = ref([]);
    for (let i = 0; i <= diff; i++) {
      months.value.push({
        label: dayjs("2021-07-01").add(i, "month").format("MM/YYYY"),
        value: dayjs("2021-07-01").add(i, "month").format(),
      });
    }

    months.value.sort((a, b) => (dayjs(b.value).isAfter(dayjs(a.value)) ? 1 : -1));

    const yesterday = {
      label: "Yesterday",
      value: dayjs().add(-1, "day").format(),
    };
    months.value.unshift(yesterday);
    const selected = ref(months.value[0]);

    let dataRows = ref({
      totalPlayer: 0,
      totalBet: 0,
      totalBetAmount: 0,
      totalValidBet: 0,
      totalBonusAmount: 0,
      totalWinLoss: 0,
      data: [],
    });
    let dataCount = ref(0);
    let isLoaded = ref(false);

    onMounted(() => {
      refetch();
    });

    const refetch = () => {
      // console.log(selected.value.value)
      let fromParams = dayjs(selected.value.value).startOf("month").format();
      let toParams = dayjs(selected.value.value).endOf("month").format();
      // console.log(fromParams, toParams)
      if (selected.value.label == "Yesterday") {
        fromParams = dayjs(selected.value.value)
            .hour(0)
            .minute(0)
            .second(0)
            .format();
        toParams = dayjs(selected.value.value)
            .hour(23)
            .minute(59)
            .second(59)
            .format();
      }
      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT + "/admin/api/v1/report/game-op",
          null,
          {
            params: {
              operatorId: store.state.selectedOperator.operatorId,
              from: fromParams,
              to: toParams,
            },
          }
        )
        .then(({ data }) => {
          build(data.result.rows);
        })
        .catch(({ response }) => {
          console.log(response.data);
        });
    };

    const search = (option) => {
      let fromParams = dayjs(option.value).startOf("month").format();
      let toParams = dayjs(option.value).endOf("month").format();

      isLoaded.value = false;
      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT + "/admin/api/v1/report/game-op",
          null,
          {
            params: {
              operatorId: store.state.selectedOperator.operatorId,
              from: fromParams,
              to: toParams,
            },
          }
        )
        .then(({ data }) => {
          build(data.result.rows);
        })
        .catch((err) => {
          console.log(err);
          isLoaded.value = true;
        });
    };

    const prev = () => {
      if (route.query.page && route.query.page !== "1") {
        router
          .push({
            query: {
              page: parseInt(route.query.page) - 1,
            },
          })
          .then(() => {
            refetch();
          });
      }
    };

    const build = (rawData) => {
      let providers = [];
      let rows = [];
      for (let i = 0; i < rawData.length; i++) {
        const row = rawData[i];
        if (!providers.includes(row.gameId)) {
          providers.push(row.gameId);
          let providerDataRows = rawData.filter((r) => r.gameId == row.gameId);

          rows.push({
            gameId: row.gameId,
            data: providerDataRows,
            totalPlayer: providerDataRows
              .map((p) => parseFloat(p.TotalPlayer))
              .reduce((a, b) => a + b, 0),
            totalBet: providerDataRows
              .map((p) => parseFloat(p.TotalBet))
              .reduce((a, b) => a + b, 0),
            totalBetAmount: providerDataRows
              .map((p) => parseFloat(p.betAmount))
              .reduce((a, b) => a + b, 0),
            totalValidBet: providerDataRows
              .map((p) => parseFloat(p.validBetAmount))
              .reduce((a, b) => a + b, 0),
            totalBonusAmount: providerDataRows
              .map((p) => parseFloat(p.bonusAmount))
              .reduce((a, b) => a + b, 0),
            totalWinLoss: providerDataRows
              .map((p) => parseFloat(p.winLoss))
              .reduce((a, b) => a + b, 0),
            totalRollbackDeposit: providerDataRows
                .map((p) => parseFloat(p.rollbackDepositAmount))
                .reduce((a, b) => a + b, 0),
            totalRollbackWithdraw: providerDataRows
                .map((p) => parseFloat(p.rollbackWithdrawAmount))
                .reduce((a, b) => a + b, 0),
            totalRawBet: providerDataRows
              .map((p) => parseFloat(p.raw_bet) || 0)
              .reduce((a, b) => a + b, 0),
            totalRawSettle: providerDataRows
              .map((p) => parseFloat(p.raw_settle) || 0)
              .reduce((a, b) => a + b, 0),
            totalCancelAmount: providerDataRows
              .map((p) => parseFloat(p.cancel_amount) || 0)
              .reduce((a, b) => a + b, 0),
            totalCancelCount: providerDataRows
              .map((p) => parseFloat(p.cancel_count) || 0)
              .reduce((a, b) => a + b, 0),
            winLossMeanPercentage:
              providerDataRows
                .map((p) => parseFloat(p.winLossPercentage))
                .reduce((a, b) => a + b, 0) / providerDataRows.length,
            date: providerDataRows[0].date,
          });
          // console.log('rows', JSON.stringify(rows))
        }
      }

      let build = {
        totalPlayer: rawData
          .map((p) => parseFloat(p.TotalPlayer))
          .reduce((a, b) => a + b, 0),
        totalBet: rawData
          .map((p) => parseFloat(p.TotalBet))
          .reduce((a, b) => a + b, 0),
        totalValidBet: rawData
          .map((p) => parseFloat(p.validBetAmount))
          .reduce((a, b) => a + b, 0),
        totalBetAmount: rawData
          .map((p) => parseFloat(p.betAmount))
          .reduce((a, b) => a + b, 0),
        totalBonusAmount: rawData
          .map((p) => parseFloat(p.bonusAmount))
          .reduce((a, b) => a + b, 0),
        totalWinLoss: rawData
          .map((p) => parseFloat(p.winLoss))
          .reduce((a, b) => a + b, 0),
        totalRollbackDeposit: rawData
            .map((p) => parseFloat(p.rollbackDepositAmount))
            .reduce((a, b) => a + b, 0),
        totalRollbackWithdraw: rawData
            .map((p) => parseFloat(p.rollbackWithdrawAmount))
            .reduce((a, b) => a + b, 0),
        totalRawBet: rawData
          .map((p) => parseFloat(p.raw_bet) || 0)
          .reduce((a, b) => a + b, 0),
        totalRawSettle: rawData
          .map((p) => parseFloat(p.raw_settle) || 0)
          .reduce((a, b) => a + b, 0),
        totalCancelAmount: rawData
          .map((p) => parseFloat(p.cancel_amount) || 0)
          .reduce((a, b) => a + b, 0),
        totalCancelCount: rawData
          .map((p) => parseFloat(p.cancel_count) || 0)
          .reduce((a, b) => a + b, 0),
        data: rows,
      };

      dataRows.value = build;
      dataCount.value = 0;
      isLoaded.value = true;

      // console.log("build", JSON.stringify(build))
    };

    const next = () => {
      router
        .push({
          query: {
            page: parseInt(route.query.page) + 1 || 2,
          },
        })
        .then(() => {
          refetch();
        });
    };

    const viewData = (data) => {
      router.push({ name: "Wallet Info", params: { id: data.id } });
    };

    const doSort = (attName) => {
      if (sortBy.value[0] && sortBy.value[0][0] == attName) {
        sortBy.value[0][1] = sortBy.value[0][1] * -1;
      } else {
        sortBy.value = [[attName, -1]];
      }

      dataRows.value.data = dataRows.value.data.sort((a, b) => {
        let fa = a[attName] ? a[attName] : null,
          fb = b[attName] ? b[attName] : null;

        if (sortBy.value[0][1] == -1) {
          if (fa < fb) {
            return -1;
          }
          if (fa > fb) {
            return 1;
          }
        } else {
          if (fa > fb) {
            return -1;
          }
          if (fa < fb) {
            return 1;
          }
        }

        return 0;
      });

      isLoaded.value = true;
    };

    const searchRage = (e) => {
      let from = dayjs(fromDate.value).hour(0).minute(0).second(0);
      let to = dayjs(toDate.value).hour(23).minute(59).second(59);
      if (
        (e.code == "Enter" || e.code == "NumpadEnter" || e.type == "change" || e.keyCode == 13) &&
        from.isValid() &&
        to.isValid() &&
        from.isBefore(to)
      ) {
        isLoaded.value = false;
        axios
          .post(
            process.env.VUE_APP_API_ENDPOINT + "/admin/api/v1/report/game-op",
            null,
            {
              params: {
                operatorId: store.state.selectedOperator.operatorId,
                from: from.format(),
                to: to.format(),
              },
            }
          )
          .then(({ data }) => {
            build(data.result.rows);
          })
          .catch((err) => {
            console.log(err);
            isLoaded.value = true;
          });
      }
    };

    const exports = () => {
      let fromParams = dayjs(selected.value.value).startOf("month").format();
      let toParams = dayjs(selected.value.value).endOf("month").format();
      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT +
            "/admin/api/v1/report/export/game-op",
          null,
          {
            params: {
              operatorId: store.state.selectedOperator.operatorId,
              from: fromParams,
              to: toParams,
            },
          }
        )
        .then(({ data }) => {
          window.open(data.result);
        });
    };

    return {
      dataRows,
      dataCount,
      isLoaded,
      dayjs,
      selected,
      toDate,
      route,
      prev,
      next,
      search,
      viewData,
      months,
      pages,
      doSort,
      fromDate,
      searchRage,
      exports,
    };
  },
};
</script>
